import styled, { css } from 'styled-components'

const getArtefactHeight = count => `${count >= 2 || count <= 8 ? 69 : 70}vh`

export const Controls = styled.div`
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    background: #f2f2f2;
    ${props =>
        props.isWhiteboardMode
            ? css`
                  height: 99vh;
                  left: 0;
                  bottom: 0;
                  width: 3.5vw;
              `
            : css`
                  position: absolute;
                  height: ${props => getArtefactHeight(props.studentsCount)};
                  width: 3.5vw;
                  left: 0;
              `}
    border-radius: 12px 0 0 12px;
    z-index: 33;
    @media only screen and (min-width: 1024px) and (max-width: 1366px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 2) {
        ${props =>
            !props.isWhiteboardMode
                ? css`
                      height: 55vh;
                  `
                : null}
    }
    @media only screen and (max-width: 992px) {
        height: 85vh;
    }
`

export const Control = styled.span`
    background: #fff;
    border-radius: 50%;
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px 0px 1px;
    cursor: pointer;
    border: 1px solid #e0e0e0;
    width: 36px;
    height: 36px;
    pointer-events:${props =>
        props.disableUndo || props.disableRedo ? 'none' : null};
    opacity:${props => (props.disableUndo || props.disableRedo ? '0.5' : null)};
    ${props =>
        props.isClicked &&
        css`
            background: #e87d7c;
            border: 1px solid #e87d7c;
        `}
    }
    &:active{
         transform: translateY(2px);
    }
    @media only screen and (min-width: 1024px) and (max-width: 1366px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 2) {
        ${props =>
            !props.isWhiteboardMode
                ? css`
                      width: 30px;
                      height: 30px;
                  `
                : null}
    }
    @media only screen and (max-width: 992px) {
        ${props =>
            !props.isWhiteboardMode
                ? css`
                      height: 20px;
                      width: 20px;
                  `
                : null}
    }
`

export const Icon = styled.img`
    height: 20px;
    width: 20px;
    @media only screen and (max-width: 992px) {
        ${props =>
            !props.isWhiteboardMode
                ? css`
                      height: 10px;
                      width: 10px;
                  `
                : null}
    }
`
